module.exports = __webpack_public_path__ + "static/media/empty-courses.047d74c0.svg";